import { Flag } from '@blueprint/ui';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const CardImagePlaceholder = styled('div')(
    ({ theme }) => css`
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        background: ${theme.colors['graphic-background-accent']};
    `
);

export const ListingFlag = styled(Flag)(
    ({ theme: { spacing } }) => css`
        position: absolute;
        margin: ${spacing['spacing-2']} 0 0 ${spacing['spacing-2']};
        top: 0;
    `
);

export const PropertyImage = styled('div')(
    ({ theme: { colors } }) => css`
        position: relative;
        width: 100%;
        height: 11.125rem; /* 178px */
        background: ${colors['graphic-background-accent']};
    `
);

export const ListingImageCount = styled('div')(
    ({ theme: { colors, spacing, borderRadius } }) => css`
        align-items: center;
        background-color: ${colors['white-opacity80']};
        border-radius: ${borderRadius.pill};
        bottom: ${spacing['8px']};
        display: inline-flex;
        flex-direction: row;
        justify-content: center;
        padding: ${spacing['4px']} ${spacing['16px']};
        position: absolute;
        width: auto;
        > svg {
            margin-right: ${spacing['4px']};
        }
    `
);
